// fe/src/utils/debug.js
export const DEBUG = process.env.REACT_APP_DEBUG === "true";

export const log = (...args) => {
  if (DEBUG) {
    console.log(...args);
  }
};
